import { useCallback } from 'react';
import { useSpace } from './useSpace';

export function useSpacePath() {
  const { currentSpace } = useSpace();
  const base = `/spaces/${currentSpace?.slug}`;

  const spacePath = useCallback(
    (path: string) => `${base}${path.startsWith('/') ? path : `/${path}`}`,
    [base]
  );

  return spacePath;
}
